export const lightTheme = {
  color: {
    brand: '#0F172A',
    accent: '#2563EB',
    accentHover: '#1D4ED8',
    success: '#059669',
    warning: '#D97706',
    danger: '#DC2626',
    muted: '#64748B',
    text: '#0F172A',
    textSoft: '#475569',
    surface: '#FFFFFF',
    surfaceAlt: '#F8FAFC',
    border: '#E2E8F0',
    borderStrong: '#CBD5E1',
  },
  chart: {
    categorical: ['#2563EB', '#059669', '#D97706', '#DC2626', '#7C3AED', '#0891B2', '#DB2777', '#65A30D'],
    positive: '#059669',
    negative: '#DC2626',
    neutral: '#64748B',
  },
  font: {
    family: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    size: { xs: 12, sm: 14, base: 16, lg: 20, xl: 24, xxl: 32 },
    weight: { regular: 400, medium: 500, semibold: 600, bold: 700 },
  },
  space: { xs: 4, sm: 8, md: 12, base: 16, lg: 24, xl: 32, xxl: 48 },
  radius: { sm: 6, md: 8, lg: 12 },
  shadow: {
    sm: '0 1px 2px 0 rgba(15,23,42,0.06), 0 1px 3px 0 rgba(15,23,42,0.04)',
    md: '0 4px 12px -2px rgba(15,23,42,0.12), 0 2px 6px -2px rgba(15,23,42,0.08)',
  },
};

export const darkTheme = {
  ...lightTheme,
  color: {
    brand: '#F8FAFC',
    accent: '#3B82F6',
    accentHover: '#60A5FA',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
    muted: '#94A3B8',
    text: '#F8FAFC',
    textSoft: '#CBD5E1',
    surface: '#0F172A',
    surfaceAlt: '#020617',
    border: '#1E293B',
    borderStrong: '#334155',
  },
  shadow: {
    sm: '0 1px 2px 0 rgba(0,0,0,0.4)',
    md: '0 4px 12px -2px rgba(0,0,0,0.5)',
  },
};
